module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "page-on-center rowBackgroundHomepage",
    attrs: {
      "id": "inbox",
      "data-page": "inbox-page",
      "pull-to-refresh": _vm.isSmartphoneOS,
      "infinite-scroll": ""
    },
    on: {
      "ptr:refresh": function($event) {
        return _vm.onRefresh(false)
      },
      "infinite": _vm.onInfinite
    }
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "listPage",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('b-row', {
    staticClass: "form-group justify-content-start showLargeScreenOnly"
  }, [_c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "disabled": _vm.activateSpinner
    },
    on: {
      "click": function($event) {
        return _vm.refreshInbox()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "refresh"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fab-label"
  }, [_vm._v(_vm._s(_vm.$t('common.rfrsh')))])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "2"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "href": "/verifications/create/"
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s('Vérifier'))])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "requestsList"
  }, [_c('div', [_c('cm-messages-filter', {
    staticClass: "researchfilter",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    },
    attrs: {
      "isVerifications": "",
      "filterType": "list",
      "mode": this.mode,
      "randomId": _vm.randomId
    },
    on: {
      "applyFilter": function($event) {
        return _vm.applyFilter($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [(_vm.activateSpinner) ? _c('spinner') : _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "sellersResults"
  }, [_c('thead', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n                    " + _vm._s('Date') + "\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n                    " + _vm._s('SIREN') + "\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n                    " + _vm._s('SIRET') + "\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v("\n                    " + _vm._s('Dénomination') + "\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "255px"
    }
  }, [_vm._v("\n                    " + _vm._s('Statut') + "\n                  ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("\n                    " + _vm._s('Actions') + "\n                  ")])]), _vm._v(" "), _c('tbody', [(_vm.inboxMessages.length > 0) ? _vm._l((_vm.inboxMessages), function(result, index) {
    return _c('tr', {
      key: index,
      staticClass: "boxRequest"
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "title": result.DateVerifications
      }
    }, [_vm._v(_vm._s(result.DateVerifications))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "title": result.Siren
      }
    }, [_vm._v(_vm._s(result.Siren))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "title": result.Siret
      }
    }, [_vm._v(_vm._s(result.Siret))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "title": result.SocialReason
      }
    }, [_vm._v(_vm._s(result.SocialReason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "title": _vm.getKYCVerificationsStatus(result.Status)
      }
    }, [_c('b-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "sm": "2"
      }
    }, [_c('i', {
      staticClass: "icon list-icon",
      class: _vm.getKYCVerificationsIcon(result.Status)
    })]), _vm._v(" "), _c('b-col', {
      staticStyle: {
        "padding-top": "5px"
      },
      attrs: {
        "sm": "10"
      }
    }, [_c('span', {
      staticStyle: {
        "margin-left": "-50px"
      }
    }, [_vm._v(_vm._s(_vm.getKYCVerificationsStatus(result.Status)))])])], 1)], 1)], 1), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "fileClickButton",
      on: {
        "click": function($event) {
          return _vm.redirectDetails(result)
        }
      }
    }, [_vm._v("\n                          " + _vm._s(_vm.$t('common.cnslt')) + "\n                        ")])])])
  }) : _c('tr', [_c('td', {
    staticClass: "noResult",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('common.no_result')) + "\n                    ")])])], 2)])])], 1)])])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3893fe92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3893fe92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/VerificationsListPage.vue
// module id = 2384
// module chunks = 2